import { FetchData } from "services/api";
import { buildDashboardDataBody } from "utils/stats/dashboardFetchBody";

export const fetchDashboardData = (params) =>
  FetchData("/api/dashboard/data", {
    method: "POST",
    body: JSON.stringify(buildDashboardDataBody(params)),
  });
